<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span v-if="actionType === 'ADD'">Adding AP</span>
              <span v-else>Edit AP</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <!-- ame, code, permission,bras, ipPool,cityCode, cpLink, cp, type -->
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Name*"
                      v-model="form.name"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Code*"
                      v-model="form.code"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Permission*"
                      v-model="form.permission"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="bras"
                      label="Bras"
                      :rules="rules.required"
                      v-model="form.bras"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="IP Pool*"
                      v-model="form.ipPool"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="City Code*"
                      v-model="form.cityCode"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="CP Link*"
                      v-model="form.cpLink"
                      :rules="rules.required"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="cp"
                      label="CP"
                      :rules="rules.required"
                      v-model="form.cp"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      :items="type"
                      label="Type"
                      :rules="rules.required"
                      v-model="form.type"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click="closeDialog()">
                Close
              </v-btn>

              <v-btn
                v-if="actionType === 'Add'"
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>

              <v-btn
                v-else
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onUpdate()"
                class="px-10"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- <Snackbars :isShow="isShow" :testDisplay="textDisplay"></Snackbars> -->
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
// import Snackbars from "./Snackbars.vue";
export default {
  name: "AddApDialog",
  components: {
    // Snackbars
  },
  data() {
    return {
      bras: ["ZTE", "HUAWEI"],
      type: ["AP", "ONU"],
      cp: ["ZTE", "SJC", "IMUS", "GO_FIBER"],

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      form: {
        name: "",
        code: "",
        permission: "",
        bras: "",
        ipPool: "",
        cityCode: "",
        cpLink: "",
        cp: "",
        type: "",
      },
    };
  },

  props: ["dialog", "actionType", "data"],
  methods: {
    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      // this.$emit("response", true);
      await this.$api
        .post("/ap-list", this.form)
        .then((response) => {
          const res = response.data;

          this.loadingBtn = false;
          this.$refs.form.reset();

          if (!res.status) {
            this.$emit("response", {
              status: false,
              message: res.message,
            });
            return;
          }

          this.$emit("response", {
            status: true,
            message: "AP is successfully saved.",
          });
        })
        .catch((e) => {
          this.loadingBtn = false;
          this.$emit("response", {
            status: false,
            message: e,
          });
        });
    },

    async onUpdate() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let data = this.form;
      data._id = this.$props.data._id;
      await this.$api
        .post("/ap-list", data)
        .then((response) => {
          const res = response.data;

          this.loadingBtn = false;
          this.$refs.form.reset();

          if (!res.status) {
            this.$emit("response", {
              status: false,
              message: res.message,
            });
            return;
          }

          this.$emit("response", {
            status: true,
            message: "AP is successfully updated.",
          });
        })
        .catch((e) => {
          this.loadingBtn = false;
          this.$emit("response", {
            status: false,
            message: e,
          });
        });
    },
    closeDialog() {
      this.$emit("close", true);
      this.$refs.form.reset();
    },

    // formatDate(d) {
    //   return moment(d).format("YYYY-MM-DD HH:mm:ss");
    // },
  },
  watch: {
    data() {
      // con

      setTimeout(() => {
        // this.form.name = this.$props.data.name;
        // this.form.code = this.$props.data.code;
        // this.form.permission = this.$props.data.permission;
        // this.form.bras = this.$props.data.bras;
        // this.form.ipPool = this.$props.data.ipPool;
        // this.form.cityCode = this.$props.data.cityCode;
        // this.form.cpLink = this.$props.data.cpLink;
        // this.form.cp = this.$props.data.cp;
        // this.form.type = this.$props.data.type;

        const currentData = this.$props.data;
        const form = this.form;

        Object.keys(form)
          .filter((key) => key in currentData)
          .forEach((key) => {
            form[key] = currentData[key];
          });

        // console.log(this.$props.data);
      }, 500);
      // this.form =  { ...this.data}
    },
  },
};
</script>
